<template>
  <v-container fluid>
    <div id="content">
      
      <template v-if="$route.path == '/projects'">

        <section class="d-flex">
          <BreadCrumb :items="$route.matched"></BreadCrumb>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.stop="dialog = true" depressed>新しい{{ $route.name }}を作成</v-btn>
        </section>

        <v-card flat>
          <v-card-title>
            <v-row>
              <v-col cols="6" md="3">
                <v-text-field
                  v-model="filterKeyword.name"
                  label="案件名"
                  outlined clearable hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="6" md="3">
                <v-combobox
                  ref="corporate"
                  label="担当企業"
                  v-model="filterKeyword.corporate"
                  :items="corporateLabels"
                  append-icon="fas fa-list-ol"
                  @click.stop="openSelected('corporate')"
                  readonly outlined clearable hide-details="auto">
                </v-combobox>
              </v-col>
              <v-col cols="6" md="3">
                <v-combobox
                  ref="customer"
                  label="客先"
                  v-model="filterKeyword.customer"
                  :items="customer"
                  append-icon="fas fa-list-ol"
                  @click.stop="openSelected('customer')"
                  readonly outlined clearable hide-details="auto">
                </v-combobox>
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table
            :headers="tableHeaders"
            :items="filterItems"
            :sort-by="['updatedAt']"
            :sort-desc="[true]"
            :loading="loading"
            @click:row="onRowClick">
              <template v-slot:item.customerID="{ item }">
                <template v-if="item.customerID">
                  {{ item.customer.name }}
                  <template v-if="item.customer.office">
                    （{{ item.customer.office }}）
                  </template>
                </template>
              </template>
              <template v-slot:item.corporateID="{ item }">
                {{ getCorporateLabel(item.corporateID) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ getDateTime(item.updatedAt) }}
              </template>
          </v-data-table>
        </v-card>

        <!-- 編集ダイアログ -->
        <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="600" id="dialog" class="edit-dialog">
          <v-card flat class="drawer-card">
            <v-card-title class="dialog-header">
              <span class="title font-weight-light">{{ $route.name }}を{{ this.editedIndex === -1 ? '追加' : '編集' }}</span>
            </v-card-title>
            <v-card-text class="scroll-content">
              <v-form v-model="valid">
                <section class="accordion_inner">
                  <v-row no-gutters>
                    <v-col cols="12" class="pa-2">
                      <v-text-field
                        ref="code"
                        label="案件コード"
                        v-model="editedItem.code"
                        outlined hide-details="auto">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" class="pa-2">
                      <v-text-field
                        ref="name"
                        label="案件名"
                        v-model="editedItem.name"
                        :rules="[rules.required]"
                        class="required"
                        outlined hide-details="auto">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" class="pa-2">
                      <v-combobox
                        ref="corporateID"
                        label="担当企業"
                        v-model="editedItem.corporateID"
                        :rules="[rules.required]"
                        class="required"
                        :items="corporateLabels"
                        append-icon="fas fa-list-ol"
                        @click.stop="openSelected('corporateID')"
                        readonly outlined hide-details="auto">
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" class="pa-2">
                      <v-combobox
                        ref="customerID"
                        label="客先"
                        v-model="editedItem.customerID"
                        :rules="[rules.required]"
                        class="required"
                        :items="customer"
                        append-icon="fas fa-list-ol"
                        @click.stop="openSelected('customerID', true)"
                        readonly outlined hide-details="auto">
                      </v-combobox>
                    </v-col>
                    <v-col cols="6" class="pa-2">
                      <v-menu
                        v-model="delivery"
                        :close-on-content-click="false"
                        :nudge-right="0"
                        transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            ref="deliveryDate"
                            label="希望納期"
                            v-model="editedItem.deliveryDate"
                            v-on="on"
                            outlined clearable hide-details="auto">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="editedItem.deliveryDate" @input="delivery = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" class="pa-2">
                      <v-textarea
                        ref="description"
                        label="備考"
                        v-model="editedItem.description"
                        rows="10"
                        outlined hide-details="auto">
                      </v-textarea>
                    </v-col>
                  </v-row>
                </section>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" text x-large>
                <v-icon left>fas fa-save</v-icon>{{ this.editedIndex === -1 ? '登録' : '更新' }}
              </v-btn>
              <v-btn color="error" @click.stop="remove" :loading="saving" v-if="editedIndex > -1" text x-large>
                <v-icon left>fas fa-trash-alt</v-icon>削除
              </v-btn>
              <v-btn @click="dialog = false" text x-large>
                <v-icon left>fas fa-times</v-icon>閉じる
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-navigation-drawer>

      </template>
      <template v-else>

        <router-view></router-view>
        
      </template>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation, Storage } from 'aws-amplify'
import { createProject, createCustomer } from '../graphql/mutations'
import { listProjects, listCustomers, listCorporates } from '../graphql/queries'
import { 
  onCreateProject, onUpdateProject, onDeleteProject,
  onCreateCustomer, onUpdateCustomer, onDeleteCustomer } from '../graphql/subscriptions'

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '案件名', align: 'start', value: 'name' },
        { text: '担当企業', align: 'start', value: 'corporateID' },
        { text: '客先', align: 'start', value: 'customerID' },
        { text: '希望納期', align: 'start', value: 'deliveryDate' },
        { text: '更新日時', align: 'start', value: 'updatedAt' },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      corporates: [],
      customers: [],
      editedIndex: -1,
      editedItem: {
        documents: [],
      },
      filterKeyword: {},
      subscription: {},
      delivery: false,
    }
  },
  prop: {},
  mounted: async function() {
    let timer = setInterval(() => {
      if (this.getMyself()) {
        clearInterval(timer)
        this.init();
      }
    }, 100)

    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateProject)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateProject
        this.desserts.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateProject)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateProject
        this.desserts.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteProject)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteProject
        this.desserts = this.desserts.filter(origin => origin.id !== row.id)
      }
    })
    //customer作成時 subscription
    await API.graphql(graphqlOperation(onCreateCustomer)).subscribe({
      next: (e) => {
        const data = e.value.data.onCreateCustomer
        this.customers.push(data)
      }
    })
    //customer更新時 subscription
    await API.graphql(graphqlOperation(onUpdateCustomer)).subscribe({
      next: (e) => {
        const data = e.value.data.onUpdateCustomer
        this.customers.find(origin => {
          if (origin.value === data.id) {
            origin = Object.assign(origin, data)
          }
        })
      }
    })
    //customer削除時 subscription
    await API.graphql(graphqlOperation(onDeleteCustomer)).subscribe({
      next: (e) => {
        const data = e.value.data.onDeleteCustomer
        this.customers = this.customers.filter(origin => origin.value !== data.id)
      }
    })
    
    
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    filterItems() {
      const map = []
      for (const item of this.desserts) {
        //案件コード
        if (this.filterKeyword.code && (!item.code || item.code.indexOf(this.filterKeyword.code) < 0) ) continue
        //案件名
        if (this.filterKeyword.name && item.name.indexOf(this.filterKeyword.name) < 0) continue
        //担当企業
        if (this.filterKeyword.corporate && this.filterKeyword.corporate.value != item.corporateID) continue
        //客先
        if (this.filterKeyword.customer && this.filterKeyword.customer.value != item.customerID) continue
        map.push(item)
      }
      return map
    },
    project() {
      return {
        id: this.editedItem.id || null,
        code: this.editedItem.code || null,
        name: this.editedItem.name || null,
        corporateID: this.editedItem.corporateID ? this.editedItem.corporateID.value: null,
        customerID: this.editedItem.customerID ? this.editedItem.customerID.value: null,
        deliveryDate: this.editedItem.deliveryDate || null,
      }
    },
    customer() {
      const map = []
      this.customers.forEach(e => {
        map.push({
          value: e.id,
          text: e.name + (e.office ? '（' + e.office + '）' : ''),
        })
      })
      return map
    },
    corporateLabels() {
      const map = []

      for (const item of this.corporates) {
        map.push({
          value: item.id,
          text: item.name,
        })
      }

      return map
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.corporateLabels.length == 1) {
          this.$set(this.editedItem, 'corporateID', this.corporateLabels[0])
        }
      }
      val || this.close()
    },
  },
  methods: {
    //初期化
    async init() {
      //一覧 query
      await this.getProjects()
      //企業情報 query
      await this.getCorporates()
      //客先 query
      await this.getCustomers()

      this.loading = false
    },
    //行選択
    onRowClick(params) {
      this.$router.push('/project/' + params.id)
    },
    //保存
    async save() {
      try {
        this.saving = true
        const row = this.project
        let id = row.id

        //客先が追加された場合
        if (!row.customerID) {
          const customer = {
            name: this.editedItem.customerID,
            payment: ['銀行振込'],
          }
          const ret = await API.graphql(graphqlOperation(createCustomer, {input: customer}))
          this.log({ type: this.$route.name, text: 'プロジェクトにて [' + customer.name + '] を追加しました' })
          //追加した客先IDを設定
          row.customerID = ret.data.createCustomer.id
        }
        //新規
        delete row.id
        const ret = await API.graphql(graphqlOperation(createProject, {input: row}))
        this.log({ type: this.$route.name, text: '[' + row.name + '] を追加しました' })
        id = ret.data.createProject.id
        //説明
        await Storage.put('project/description/' + id + '.html', this.editedItem.description)

        this.dialog = false
      } catch (e) {
        //console.log(e)
        this.myAlert(e)
        this.saving = false
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      //this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f] && !!this.$refs[f].reset) this.$refs[f].reset()
      })
      this.editedItem.id = null
      this.editedItem.description = null
      //アコーディオンの全開
      document.querySelectorAll('h3 .ctrl-btn').forEach(e => e.classList.add('opened'))
      document.querySelectorAll('.accordion_inner').forEach(e => e.style.display = 'block')
      //スクロールのリセット
      this.scrollReset()
    },
    //スクロールを戻す
    scrollReset() {
      let container = document.getElementsByClassName('scroll-content')[0]
      container.scrollTop = 0
    },
    //企業
    getCorporateLabel(id) {
      const corporate = this.corporateLabels.find(e => e.value === id)
      return corporate ? corporate.text : null
    },
    //プロジェクトの取得
    async getProjects(nextToken = null) {
      //所属企業
      const myself = this.getMyself()
      const corporateFilter = []
      for (const id of myself.corporateIDs) {
        corporateFilter.push({
          corporateID: { eq: id }
        })
      }
      //query
      const query = await API.graphql(graphqlOperation(listProjects, {
        filter: {
          or: corporateFilter
        },
        limit: 500, 
        nextToken: nextToken 
      }))
      for (const data of query.data.listProjects.items) {
        this.desserts.push(data)
      }
      if (query.data.listProjects.nextToken) this.getProjects(query.data.listProjects.nextToken)
    },
    //企業の取得
    async getCorporates(nextToken = null) {
      //所属企業
      const myself = this.getMyself()
      const corporateFilter = []
      for (const id of myself.corporateIDs) {
        corporateFilter.push({
          id: { eq: id }
        })
      }
      //query
      const query = await API.graphql(graphqlOperation(listCorporates, { 
        filter: {
          or: corporateFilter
        },
        limit: 500, 
        nextToken: nextToken 
      }))
      for (const data of query.data.listCorporates.items) {
        this.corporates.push(data)
      }
      if (query.data.listCorporates.nextToken) this.getCorporates(query.data.listCorporates.nextToken)
    },
    //客先の取得
    async getCustomers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listCustomers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listCustomers.items) {
        this.customers.push(data)
      }
      if (query.data.listCustomers.nextToken) this.getCustomers(query.data.listCustomers.nextToken)
    },
  },
}
</script>

<style lang='scss' scoped>
.gallery {
  li {
    margin-right: 10px;
    vertical-align: top;
    .add-btn {
      border-color: #DDD;
      border-radius: 5px;
      width: 120px;
      height: 120px;
    }
  }
}
.model-list {
  list-style: none;
  padding: 0;
  & > li {
    position: relative;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #DDD;
    &:last-of-type {
      padding-bottom: 0;
      margin-bottom: 0;
      border-bottom: none;
    }
    .model-image {
      position: absolute;
      top: 5px;
      left: 0;
    }
    .model-row {
      list-style: none;
      padding: 0;
      letter-spacing: -.4em;
      margin-left: 140px;
      margin-right: 80px;
      li {
        letter-spacing: normal;
        display: inline-block;
        padding: 5px;
        &.name { width: 25%; padding-left: 0; }
        &.serial { width: 25%; }
        &.code { width: 25%; }
        &.size { width: 25%; }
        &.color { width: 25%; padding-left: 0; }
        &.material { width: 25%; }
        &.value { width: 25%; }
        &.remain { width: 25%; }
        &.remark { width: 100%; padding-left: 0; }
      }
    }
    .model-ctrl {
      position: absolute;
      right: 0;
      top: 15px;
      width: 70px;
      text-align: center;
    }
  }
}
</style>
